import { Button, ButtonProps, useDisclosure } from "@chakra-ui/react";
import React, { useCallback } from "react";
import { RiAddCircleLine } from "react-icons/ri";
import { useEditFormTemplateContext } from "../context";
import {
  SectionFormDialog,
  SectionFormType,
} from "./SectionForm/SectionFormDialog";
import { createNewSection } from "./SectionForm/services";

type AddSectionButtonProps = ButtonProps & {
  children?: string;
  newOrder: number;
};

export const AddSectionButton: React.FC<AddSectionButtonProps> = ({
  children,
  onClick,
  newOrder,
  leftIcon,
  ...buttonProps
}) => {
  const { onOpen, onClose, isOpen } = useDisclosure();
  const { dispatch } = useEditFormTemplateContext();

  const handleAddNewSection = useCallback(
    (values: SectionFormType) => {
      if (!dispatch) {
        return;
      }

      const newSection = createNewSection(values);

      dispatch({
        type: "AddSection",
        atIndex: newOrder,
        section: newSection,
      });

      onClose();
    },
    [dispatch, newOrder, onClose]
  );

  return (
    <>
      <Button
        variant="outline"
        colorScheme="gray"
        leftIcon={leftIcon ?? <RiAddCircleLine />}
        size="sm"
        alignSelf="flex-end"
        onClick={onOpen}
        {...buttonProps}
      >
        {children ?? "Add section"}
      </Button>

      <SectionFormDialog
        isOpen={isOpen}
        onCreate={handleAddNewSection}
        onCancelButtonClick={onClose}
      />
    </>
  );
};
